<template>
  <li v-if="$mq === 'md' || $mq === 'lg'"
      class="summary__item"
      :class="{ 'summary__item--disabled' : !status }">
    <div class="summary__item__icon">
        <i v-if="item.meta.icon"
          class="ic"
          :class="`ic-${item.meta.icon}`"></i>
    </div>
    <div class="summary__item__meta">
      <div class="summary__item__meta__title">
        <span v-if="item.quantity > 1"
              class="summary__item__quantity">
          x{{ item.quantity }}
        </span>
        {{ item.meta.title.summary }}
        <information :information="item.meta.information" v-if="$mq === 'md' || $mq ==='lg'"/>
        <span v-if="item.meta.title.striked" class="summary__item__meta__title__striked">{{ item.meta.title.striked }}</span>
      </div>
    </div>
    <summary-item-price v-if="!noPrice && !path.includes('fatura')"
                        :path="path"
                        :price="price"
                        :isOfferPrice="isOffer"
                        :isResumable="item.config.isResumable"/>
    <template v-if="action && !noAction">
      <a v-if="action.type === 'edit'"
         class="summary__item__action"
         @click="editItem">
         <i class="ic ic-edit-large"/>
      </a>
      <a v-else-if="!isOffer"
          class="summary__item__action"
          @click="toggleSubItem">
         <i class="ic ic-remove-large" v-if="status"/>
         <i class="ic ic-restore-large color--orange" v-else/>
      </a>
      <a v-else
          class="summary__item__action summary__item__action--disabled"
          title="Não se negam ofertas!"
          v-tippy="{
            trigger: 'click',
            theme: 'light'
          }">
         <i class="ic ic-remove-large"/>
      </a>
    </template>
  </li>
  <!-- mobile -->
  <li v-else
      class="summary__item"
      :class="{ 'summary__item--disabled' : !status }">
    <div class="summary__item__column">
      <div class="summary__item__meta">
        <div class="summary__item__meta__title">
          <span v-if="item.quantity > 1"
                class="summary__item__quantity">
            x{{ item.quantity }}
          </span>
          {{ item.meta.title.summary }}
          <summary-item-price v-if="!noPrice && !path.includes('fatura')"
                          :path="path"
                          :price="price"
                          :isOfferPrice="isOffer"
                          :isResumable="item.config.isResumable"/>
        </div>
      </div>
    </div>
    <template v-if="action && !noAction">
      <a v-if="action.type === 'edit'"
         class="summary__item__action"
         @click="editItem">
         <i class="ic ic-edit-small"/>
      </a>
      <a v-else-if="!isOffer"
          class="summary__item__action"
          @click="toggleSubItem">
         <i class="ic ic-remove-small" v-if="status"/>
         <i class="ic ic-restore-small color--orange" v-else/>
      </a>
      <a v-else
          class="summary__item__action summary__item__action--disabled"
          title="Não se negam ofertas!"
          v-tippy="{
            trigger: 'click',
            theme: 'light'
          }">
         <i class="ic ic-remove-small"/>
      </a>
    </template>
  </li>
</template>

<script>
import cartMixin from '../mixins/cart';
import determineActivePriceMixin from '../mixins/determineActivePrice';

export default {
  mixins: [
    cartMixin,
    determineActivePriceMixin
  ],
  data() {
    return {
      action: null,
      status: true
    };
  },
  props: {
    item: {
      type: Object
    },
    noAction: {
      type: Boolean,
      default: false
    },
    noPrice: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    activePrice() {
      return this.determineActivePrice(this.item.price);
    },
    realPrice() {
      const basePrice = this.item.config.basePrice ? this.item.config.basePrice : 0;
      const quantity = this.item.quantity ? this.item.quantity : 1;
      let value = 0;

      if (this.activePrice.old) {
        value = this.item.config.namespace === 'fatura_detalhe' ? 0 : (this.activePrice.old * quantity) + basePrice;
      }
      if (!this.activePrice.old) {
        value = this.item.config.namespace === 'fatura_detalhe' ? 0 : (this.activePrice.value * quantity) + basePrice;
      }

      if (this.item.path === 'fatura_detalhe.components.analog_debitodireto_maximum' || this.item.path === 'fatura_detalhe.components.analog_maximum') {
        value = (this.activePrice.value * quantity);
      }

      return value;
    },
    price() {
      return {
        absolute: this.activePrice.absolute,
        recurring: this.activePrice.recurring,
        included: this.activePrice.included,
        value: this.realPrice
      };
    },
    path() {
      return this.item.path;
    }
  },
  methods: {
    editItem() {
      this.$gm_tracker_trackAction('edition', this.item.meta.title.summary);

      this.$emit('edit-item', this.item.config.namespace);

      this.$gm_tracker_trackSummary();
    },
    toggleSubItem() {
      this.status = !this.status;

      this.$m_cart_update({
        path: this.path,
        quantity: this.status ? 1 : 0,
        uniqueInNamespace: false
      });

      this.$gm_tracker_trackSummary();
    }
  },
  mounted() {
    if (this.isEditable) {
      this.action = Object.assign({}, this.action, {
        type: this.item.config.parent && this.item.config.parent !== 'fatura' && !this.item.config.isEditable ? 'remove' : 'edit',
        label: this.item.config.parent && this.item.config.parent !== 'fatura' && !this.item.config.isEditable ? 'REMOVER' : 'EDITAR'
      });
    }
  },
  components: {
    'summary-item-price': () => import('./SummaryItemPrice'),
    information: () => import('./Information.vue')
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/SummaryItem.vue